import { useForm } from "react-hook-form";
import { CrossBrandLeadFormData } from "./types";
import { useCallback } from "react";
import { sendCrossBrandLead } from "src/ssc-api/leadAPIClient";
import { CrossBrandLeadApiRequest } from "@silversea-ssc/dotcom-api-types/CrossBrandLead";
import { LeadData } from "components/SubscribeToNewsletter/SubscribeCrossBrandOptions/SubscribeCrossBrandOptions";
import { trackCrossLeadFormSubmitted } from "src/utils/analytics/tracking";

type UseCrossBrandLeadFormOptions = {
  onSubmitSuccess: (
    formData: CrossBrandLeadFormData,
    requestData: CrossBrandLeadApiRequest
  ) => void;
  leadData: LeadData;
  formName: string;
};

export const useCrossBrandLeadForm = ({
  onSubmitSuccess,
  leadData,
  formName
}: UseCrossBrandLeadFormOptions) => {
  const defaultValues: CrossBrandLeadFormData = {
    CelebrityCruises: false,
    RoyalCaribbean: false
  };

  const formMethods = useForm<CrossBrandLeadFormData>({
    mode: "onTouched",
    reValidateMode: "onChange",
    shouldUnregister: true,
    defaultValues: defaultValues
  });
  const { formState } = formMethods;

  const onSubmit = useCallback(
    async (data: CrossBrandLeadFormData) => {
      try {
        if (!formState.isValid) {
          return false;
        }

        const patchedData: CrossBrandLeadApiRequest = {
          ...data,
          Title: leadData.leadFormData.Title!,
          FirstName: leadData.leadFormData.NameFirst!,
          LastName: leadData.leadFormData.NameLast!,
          Email: leadData.leadFormData.Email!
        };

        await sendCrossBrandLead(patchedData);
        trackCrossLeadFormSubmitted({
          ...leadData.leadApiResponse,
          formName
        });
        onSubmitSuccess(patchedData, patchedData);

        return true;
      } catch (e) {
        console.error("request", e);
      }
      return false;
    },
    [formState.isValid, onSubmitSuccess, leadData]
  );

  return {
    formMethods,
    onSubmit
  };
};
